import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* validateEmail(action) {
    const url = api.buildValidateEmailUrl();
    const {response, data} = yield call(FetchService.post,
        {
            url: url,
            params: action.payload.params
        }
    );
    return responseObject(response, data, action);
}

function* validateUsername(action) {
    const url = api.buildValidateUsernameUrl();
    const {response, data} = yield call(FetchService.post, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;

    return responseObject(response, data, action);
}

function* validatePassword(action) {
    const url = api.buildValidatePasswordUrl();
    const {response, data} = yield call(FetchService.post, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;

    return responseObject(response, data, action);
}



function* requestEmailVerification(action) {
    let valid_email = yield call(validateEmail, action);
    if(valid_email.error) {
        yield put(actions.requestEmailVerificationResponse(valid_email));
        return;
    }

    const url = api.buildRequestEmailVerificationUrl();
    const {response, data} = yield call(FetchService.post, {
        url: url,
        params: action.payload.params
    });
    yield put(actions.requestEmailVerificationResponse(responseObject(response, data, action)));
}

function* watchRequestEmailVerification() {
    yield takeLatest(ty.REQUEST_EMAIL_VERIFICATION_REQUEST, errorSafeSaga(requestEmailVerification));
}




function* registration(action) {
    let valid_username = yield call(validateUsername, action);
    if(valid_username.error) {
        yield put(actions.registrationResponse(valid_username));
        return;
    }

    let valid_password = yield call(validatePassword, action);
    if(valid_password.error) {
        yield put(actions.registrationResponse(valid_password));
        return;
    }

    const url = api.buildRegistrationUrl();
    const {response, data} = yield call(FetchService.post, {
        url: url,
        params: action.payload.params
    });
    yield put(actions.registrationResponse(responseObject(response, data, action)));
}

function* watchRegistration() {
    yield takeLatest(ty.REGISTRATION_REQUEST, errorSafeSaga(registration));
}



function* login(action) {
    const url = api.buildLoginUrl();
    const {response, data} = yield call(FetchService.post, {
        url: url,
        params: action.payload.params
    });
    yield put(actions.loginResponse({payload: {response, data}}));
}

function* watchLogin() {
    yield takeLatest(ty.LOGIN_REQUEST, errorSafeSaga(login));
}


export function* authenticatedRequest(f) {
    const token = yield select(authToken)
    return function* (args) {
        const {headers, ...otherArgs} = args;
        const newArgs = {
            ...otherArgs,
            headers: {
                ...(headers ? headers : {}),
                "X-Auth-Token": token
            }
        }
        return yield call(f, newArgs);
    };
}

function* logout(action) {
    const url = api.buildLogoutUrl();
    const authPost = yield authenticatedRequest(FetchService.post);
    const {response, data} = yield call(authPost, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.logoutResponse({ payload: {data: data}, error: error }));
}

function* watchLogout() {
    yield takeLatest(ty.LOGOUT_REQUEST, errorSafeSaga(logout));
}

/*function* usersList(action) {
    const url = api.buildUsersListUrl();
    const authGet = yield authenticatedRequest(FetchService.get);
    const {response, data} = yield call(authGet, {
        url: url,
        queryParams: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.usersListResponse({ payload: {data: data}, error: error }));
}

function* watchUsersList() {
    yield takeLatest(ty.USERS_LIST_REQUEST, usersList);
}*/


function* saga() {
  yield all([
    fork(watchLogin),
    fork(watchRegistration),
    fork(watchRequestEmailVerification),
    fork(watchLogout),
    //fork(watchUsersList),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/auth/saga.js